module.exports = __webpack_public_path__ + "static/media/logo.30d6b517.png";